<template>
  <Teleport to="body">
    <Transition name="splash">
      <div 
        v-if="showSplash"
        class="splash-screen"
        role="dialog"
        aria-label="Cargando"
      >
        <!-- Backdrop sólido -->
        <div class="splash-backdrop"></div>
        
        <!-- Logo animado -->
        <div class="splash-content">
          <svg 
            class="splash-logo" 
            viewBox="0 -2 300.3 34"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Poseidonie Logo"
            preserveAspectRatio="xMidYMid meet"
          >
            <path class="cls-1" d="M19.1,8.57c0,5.62-5.22,8.13-13.08,8.13h-1.95v8.97c0,1.4.28,1.99.88,2.35v.28H0v-.28c.64-.36.92-.96.92-2.35V3.07C.92,1.63.64,1.08,0,.72v-.32h6.02c7.85,0,13.08,2.51,13.08,8.17ZM15.95,8.57C15.95,3.87,13.2,.72,6.02.72h-1.95v15.67h1.95c7.18,0,9.93-3.15,9.93-7.81Z"/>
            <path class="cls-1" d="M59.61,14.27c0,7.86-6.58,14.27-14.47,14.27s-14.47-6.42-14.47-14.27S37.24,0,45.14,0s14.47,6.38,14.47,14.27ZM55.78,11c-2.15-7.02-8.05-12.08-14.71-10.05s-8.73,9.53-6.58,16.55c2.15,7.06,8.05,12.12,14.71,10.09,6.66-2.03,8.73-9.53,6.58-16.59Z"/>
            <path class="cls-1" d="M91.83,3.75l-1.2,4.15h-.28c-2.27-5.34-5.18-7.38-8.33-7.38-3.95,0-6.22,2.23-6.46,4.62-.76,7.97,16.35,5.34,16.35,15.31,0,4.74-4.27,8.09-9.93,8.09-4.75,0-7.7-1.59-10.81-3.95l1.2-4.54h.28c2.03,4.07,5.74,7.69,10.96,7.69,3.39,0,6.22-2.19,6.54-4.7,1.04-8.49-16.11-5.78-16.11-15.79,0-3.23,2.59-7.26,9.01-7.26,3.07,0,6.42,1.91,8.77,3.75Z"/>
            <path class="cls-1" d="M120.94,23.48l-.88,4.82h-16.19v-.28c.6-.36.88-.96.88-2.35V3.07c0-1.4-.28-1.99-.88-2.35v-.32h14.91l.84,4.43-.2.16c-1.83-2.07-4.31-4.27-8.73-4.27h-2.79v11.76l10.05-.88v2.03l-10.05-.84v15.23h3.23c4.39,0,7.69-2.27,9.57-4.71l.24.16Z"/>
            <path class="cls-1" d="M136.93,3.07v22.61c0,1.4.28,1.99.92,2.35v.28h-4.94v-.28c.6-.36.88-.96.88-2.35V3.07c0-1.4-.28-1.99-.88-2.35v-.32h4.94v.32c-.64.36-.92.96-.92,2.35Z"/>
            <path class="cls-1" d="M176.16,14.35c0,7.89-6.74,13.96-15.99,13.96h-9.97v-.28c.6-.36.88-.96.88-2.35V3.07c0-1.4-.28-1.99-.88-2.35v-.32h9.97c9.25,0,15.99,6.1,15.99,13.96ZM173.01,14.35c0-7.34-4.86-13.64-12.84-13.64h-5.94v27.31h5.94c7.97,0,12.84-6.3,12.84-13.68Z"/>
            <path class="cls-1" d="M216.68,14.27c0,7.86-6.58,14.27-14.47,14.27s-14.47-6.42-14.47-14.27,6.58-14.27,14.47-14.27,14.47,6.38,14.47,14.27ZM212.85,11c-2.15-7.02-8.05-12.08-14.71-10.05-6.66,2.03-8.73,9.53-6.58,16.55,2.15,7.06,8.05,12.12,14.71,10.09s8.73-9.53,6.58-16.59Z"/>
            <path class="cls-1" d="M253.56.4v.32c-1.32.68-2.51,2.75-2.51,4.47v23.12h-.6l-18.98-24.28v19.5c0,1.71,1.2,3.83,2.55,4.5v.28h-5.38v-.28c1.36-.68,2.55-2.79,2.55-4.5V3.67l-2.55-3.27h4.03l18.06,22.89V5.18c0-1.71-1.2-3.79-2.51-4.47v-.32h5.34Z"/>
            <path class="cls-1" d="M269.95,3.07v22.61c0,1.4.28,1.99.92,2.35v.28h-4.94v-.28c.6-.36.88-.96.88-2.35V3.07c0-1.4-.28-1.99-.88-2.35v-.32h4.94v.32c-.64.36-.92.96-.92,2.35Z"/>
            <path class="cls-1" d="M300.3,23.48l-.88,4.82h-16.19v-.28c.6-.36.88-.96.88-2.35V3.07c0-1.4-.28-1.99-.88-2.35v-.32h14.91l.84,4.43-.2.16c-1.83-2.07-4.31-4.27-8.73-4.27h-2.79v11.76l10.05-.88v2.03l-10.05-.84v15.23h3.23c4.39,0,7.7-2.27,9.57-4.71l.24.16Z"/>
          </svg>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useAppStore } from '@/stores/app.store'
import { useRoute } from 'vue-router'

interface Props {
  minDuration?: number
}

const props = withDefaults(defineProps<Props>(), {
  minDuration: 1500 // Duración mínima en milisegundos
})

const emit = defineEmits<{
  complete: []
}>()

const route = useRoute()
const appStore = useAppStore()
const showSplash = ref(true)
const minDurationPassed = ref(false)
const safetyTimeoutPassed = ref(false)

// Guardar estilos originales del body para restaurarlos después
const originalBodyStyles = {
  overflow: '',
  position: '',
  width: '',
  height: ''
}

// Watch para cuando el video esté listo y haya pasado la duración mínima
watch(
  () => [appStore.isVideoReady, minDurationPassed.value, safetyTimeoutPassed.value],
  ([videoReady, durationPassed, timeoutPassed]) => {
    // Si no estamos en home, ocultar inmediatamente después de la duración mínima
    // Si estamos en home, esperar a que el video esté listo Y la duración mínima
    // Como seguridad, si pasa el timeout máximo, ocultar de todas formas
    const shouldHide = route.name !== 'home' 
      ? durationPassed 
      : ((videoReady && durationPassed) || timeoutPassed)
    
    if (shouldHide && showSplash.value) {
      // Ocultar el splash
      showSplash.value = false
      
      // Restaurar scroll del body después de que termine completamente la transición
      setTimeout(() => {
        // Usar requestAnimationFrame para sincronizar con el navegador
        requestAnimationFrame(() => {
          document.body.style.overflow = originalBodyStyles.overflow
          document.body.style.position = originalBodyStyles.position
          document.body.style.width = originalBodyStyles.width
          document.body.style.height = originalBodyStyles.height
          
          // Forzar scroll a top para que Safari reposicione las barras correctamente
          window.scrollTo(0, 0)
        })
      }, 1200) // Restaurar después de que termine completamente la transición
      
      // Emitir evento cuando se complete la animación
      setTimeout(() => {
        emit('complete')
      }, 1200) // Esperar a que termine la transición de salida
    }
  }
)

onMounted(() => {
  // Guardar estilos originales del body
  originalBodyStyles.overflow = document.body.style.overflow
  originalBodyStyles.position = document.body.style.position
  originalBodyStyles.width = document.body.style.width
  originalBodyStyles.height = document.body.style.height
  
  // Prevenir scroll del body mientras el splash está activo
  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.width = '100%'
  document.body.style.height = '100%'
  
  // Marcar que la duración mínima ha pasado
  setTimeout(() => {
    minDurationPassed.value = true
  }, props.minDuration)
  
  // Timeout de seguridad máximo (5 segundos) para evitar bloqueos
  setTimeout(() => {
    if (showSplash.value) {
      console.warn('⚠️ Splash screen timeout de seguridad activado')
      safetyTimeoutPassed.value = true
    }
  }, 5000)
})

onUnmounted(() => {
  // Restaurar estilos originales del body
  document.body.style.overflow = originalBodyStyles.overflow
  document.body.style.position = originalBodyStyles.position
  document.body.style.width = originalBodyStyles.width
  document.body.style.height = originalBodyStyles.height
})
</script>

<style scoped>
/* Splash Screen Container */
.splash-screen {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  overscroll-behavior: none;
  touch-action: none;
  -webkit-overflow-scrolling: touch;
}

/* Backdrop sólido */
.splash-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: var(--p-surface-0);
  opacity: 1;
}

/* Content container */
.splash-content {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: logoFloat 3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

/* Logo styling */
.splash-logo {
  height: 1.5rem;
  width: auto;
  padding: 0.25rem;
  animation: logoGlow 4s ease-in-out infinite alternate;
}

.splash-logo .cls-1 {
  fill: var(--p-primary-color);
  transition: fill 0.3s ease;
}

/* Desktop */
@media (min-width: 1024px) {
  .splash-logo {
    height: 2.25rem;
  }
}

/* iPad / Tablet */
@media (min-width: 768px) and (max-width: 1023px) {
  .splash-logo {
    height: 2rem;
  }
}

/* Logo animations */
@keyframes logoFloat {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  50% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes logoGlow {
  0% {
    filter: drop-shadow(0 10px 30px rgba(0, 0, 0, 0.1));
  }
  100% {
    filter: drop-shadow(0 15px 40px rgba(0, 0, 0, 0.15));
  }
}

/* Dark mode glow */
:global(.dark) .splash-logo .cls-1 {
  animation: logoGlowDark 3s ease-in-out infinite alternate;
}

@keyframes logoGlowDark {
  0% {
    filter: drop-shadow(0 10px 30px rgba(255, 255, 255, 0.15));
  }
  100% {
    filter: drop-shadow(0 15px 40px rgba(255, 255, 255, 0.25));
  }
}

/* Transition effects */
.splash-enter-active,
.splash-leave-active {
  transition: all 1.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.splash-enter-from {
  opacity: 0;
}

.splash-enter-to {
  opacity: 1;
}

.splash-leave-from {
  opacity: 1;
}

.splash-leave-to {
  opacity: 0;
}

/* Animación de salida del backdrop */
.splash-leave-active .splash-backdrop {
  transition: all 1.2s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0;
}

/* Animación de salida del logo */
.splash-leave-active .splash-logo {
  animation: logoFadeOut 1.2s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes logoFadeOut {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-40px);
  }
}

/* Soporte para movimiento reducido */
@media (prefers-reduced-motion: reduce) {
  .splash-content,
  .splash-logo,
  .splash-enter-active,
  .splash-leave-active {
    animation: none !important;
    transition: opacity 0.3s ease !important;
  }
}

/* Optimización para dispositivos móviles */
@media (max-width: 768px) {
  .splash-screen {
    position: fixed;
    inset: 0;
  }
  
  .splash-logo {
    height: 1.5rem;
  }
}

/* Fix específico para iOS Safari */
@supports (-webkit-touch-callout: none) {
  .splash-screen,
  .splash-backdrop {
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
  }
}
</style>

